import { render, staticRenderFns } from "./DelegationLockConfirmation.vue?vue&type=template&id=a1b7185c&"
import script from "./DelegationLockConfirmation.vue?vue&type=script&lang=js&"
export * from "./DelegationLockConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports